import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {ContractsDialogService} from "../../services/contracts-dialog-service.service";
import {ContractsService} from "../../services/contracts-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class ContractViewCtrl implements IController {
  contract: any;
  selectedProgramId: any;
  accountId: any;

  $stateRef: any;
  enabledPrograms: any;

  constructor(private $log, private $state, private contractsDialogService: ContractsDialogService,
              private contractsService: ContractsService, private $q: IQService, private splitService: SplitService) {
  }

  $onInit() {
    this.$stateRef = this.$state;
    this.enabledPrograms = this.getProgramMenu(this.contract.entryList);

    const activeProgram = _.find(this.enabledPrograms, (program) => {
      return program.id === this.selectedProgramId;
    })
    if (!this.selectedProgramId && activeProgram) {
      this.selectedProgramId = activeProgram.id;
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  onAddNewProgram(event, contract) {
    this.contractsDialogService.addProgramTypeToContract(event, contract)
      .then((programType) => {
        return this.contractsService.addNewProgramToContract(contract.id, programType)
      })
      .then(() => {
        this.$state.go('.', {}, {notify: true, reload: true})
      })
      .catch(() => {
        this.$log.info('Failed to add program type to contract');
      })
  }

  onEditName() {
    this.contractsDialogService.editContractName(this.contract)
      .then((newName) => {
        this.contractsService.updateContractName(this.contract.id, newName).then((contract) => {
          this.contract = contract
        })
      })
      .catch(() => {
        this.$log.info('Failed to update name');
      })
  }

  public onEditCarriersToContract($event, contract) {

    const assignedAccountIds = _.get(contract, 'accountId');

    this.contractsDialogService.editContractCarriers(assignedAccountIds)
      .then((accountsLists: { accountIdsToAdd: string[], accountIdsToRemove: string[] }) => {
        this._updateCarriers(accountsLists.accountIdsToAdd, accountsLists.accountIdsToRemove);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _updateCarriers(carriersToAdd?: string[], carriersToRemove?: string[]) {
    let promises = [];
    if (carriersToAdd && carriersToAdd.length) {
      promises.push(this._assignAccountsToContract(carriersToAdd));
    }
    if (carriersToRemove && carriersToRemove.length) {
      promises.push(this._removeAccountsFromContract(carriersToRemove));
    }

    if (promises.length) {
      this.$q.all(promises)
        .then((contract) => {
          this.contract = contract[0];
        })
    }
  }

  private _assignAccountsToContract(accountIds: string[]) {
    return this.contractsService.assignAccounts(this.contract.id, {ids: accountIds})
  }

  private _removeAccountsFromContract(accountIds: string[]) {
    return this.contractsService.removeAccounts(this.contract.id, accountIds)
  }

  private getProgramMenu(programs) {
    const enabledPrograms = _.filter(programs, (program) => {
      return program.enabled;
    });

    const siteProgramTypesMap = this.splitService.getSiteProgramTypesMap()
    return _.map(enabledPrograms, (p) => {
      return {
        name: p.programSetting?.name || siteProgramTypesMap[p.type],
        id: p.id
      }
    });
  }
}

angular
  .module('bringoz.admin.contracts')
  .component('contractView', {
    bindings: {
      contract: '<',
      selectedProgramId: '<',
      accountId: '<?'
    },
    template: require('./contract-view.html').default,
    controller: ContractViewCtrl
  });
